import { BASE_URL } from "../environment";
import makeRequest from "../makeRequest";

export default async function fetchVodafoneAppointmentSlots({ addressReference, districtCode, accessLineId, productCode }) {
  const params = new URLSearchParams();
  if (addressReference) params.set("addressReference", addressReference);
  if (districtCode) params.set("districtCode", districtCode);
  if (accessLineId) params.set("accessLineId", accessLineId);
  if (productCode) params.set("productCode", productCode);

  return makeRequest(`${BASE_URL}/vodafoneappointmentslots?${params.toString()}`, {
    method: "GET",
  });
}
